import { loadScript } from '../util/load-script';
import { Provider } from './providers.types';

const FACEBOOK_SCRIPT_TAG_ID = 'facebook-embed-script-tag';
const FACEBOOK_EMBED_SDK_URL = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2';
const FACEBOOK_EMBED_SDK_VERSION = 'v8.0';
const FACEBOOK_LOADING_TIMEOUT_MS = 15000;

export default function Facebook(): Provider {
  async function mount(element, url) {
    element.classList.remove('social-embed--rendered');

    const type = parseURL(url);

    if (type === 'video') {
      const showText = element.dataset.facebookShowVideoText === 'true';
      element.innerHTML = `
        <div class="fb-video" data-href="${url}" data-show-text="${showText}"></div>
      `;
    }

    if (type === 'post') {
      element.innerHTML = `<div class="fb-post" data-href="${url}"></div>`;
    }

    try {
      const sdk = await loadSdk();

      sdk.init({
        xfbml: true,
        version: FACEBOOK_EMBED_SDK_VERSION,
      });
    } catch (error) {
      console.warn(error);
    }
  }

  return {
    mount
  };
}

async function loadSdk(): Promise<any> {
  if (typeof window['FB']?.init === 'function') {
    return window['FB'];
  }

  await loadScript(FACEBOOK_EMBED_SDK_URL);

  return new Promise((resolve) => {
    const intervalPointer = setInterval(() => {
      if (typeof window['FB']?.init !== 'function') {
        return;
      }

      clearInterval(intervalPointer);
      clearTimeout(lifelinePointer);
      resolve(window['FB']);
    }, 50);

    // Lifeline timeout. Will be called after 15 seconds
    // to prevent interval above from running indefinitely.
    const lifelinePointer = setTimeout(() => {
      clearInterval(intervalPointer);

      // Clean up, i.e., allow subsequent attempts to reload script
      const scriptTag = document.querySelector('[src*="${FACEBOOK_EMBED_SDK_URL}"]');
      if (scriptTag) {
        scriptTag.parentElement.removeChild(scriptTag);
      }
    }, FACEBOOK_LOADING_TIMEOUT_MS);
  });
}

function parseURL(url: string) {
  const type = url.split('/')[4];

  switch (type) {
    case 'photos':
    case 'media':
    case 'notes':
    case 'posts':
      return 'post';
    case 'videos':
      return 'video';
    default:
      return console.warn('Invalid Facebook URL');
  }
}
